export const ActivityCodes = { DH: 'DH' };

export const addTaskOptions = Object.freeze({
  ABOVE: 'ABOVE',
  BELOW: 'BELOW',
});
